import React, { memo } from "react";
import { Container } from "react-bootstrap";

import { Autoplay, Pagination } from "swiper";
import { SwiperSlide } from "swiper/react/swiper-react";

import {
  WallboardCard,
  WallBoardContent,
  WallboardSwiper,
} from "./styledWallboardSection";

const WallboardSectionComponent = ({ wallboardData = [] }) => {
  return (
    <section className="pb-3 pt-lg-2 pb-lg-5">
      <Container>
        <WallboardSwiper
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          spaceBetween={8}
          slidesPerView={1}
          breakpoints={{
            375: {
              slidesPerView: 2,
            },
            576: {
              spaceBetween: 40,
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          }}
          loop={true}
          pagination={{ clickable: true }}
          modules={[Autoplay, Pagination]}
        >
          {wallboardData.map((item) => {
            return (
              <SwiperSlide key={item.id}>
                <WallboardCard>
                  <img
                    src={item.img}
                    alt={item.title}
                    width="60"
                    height="60"
                    className="img-fluid"
                  />
                  <WallBoardContent>
                    <strong>{item.count} +</strong>
                    <span>{item.title}</span>
                  </WallBoardContent>
                </WallboardCard>
              </SwiperSlide>
            );
          })}
        </WallboardSwiper>
      </Container>
    </section>
  );
};

export default memo(WallboardSectionComponent);
